// Damage photos live in the private bucket and the order stores only the
// storage path (rental_orders.damage_photo_url), so the stored value is never
// a URL. The preview loads a short-lived signed URL from the API; the click
// fetches a fresh one, like the signed-contract link on the client profile.
import { useState, useEffect } from 'react';
import axios from './lib/axiosClient';

export default function DamagePhoto({ orderId }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    axios.get(`/api/rentals/orders/${orderId}/damage-photo`)
      .then(r => { if (alive) setUrl(r.data.url); })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, [orderId]);
  const openFull = async (e) => {
    e.preventDefault();
    try { const r = await axios.get(`/api/rentals/orders/${orderId}/damage-photo`); window.open(r.data.url, '_blank', 'noopener'); }
    catch (err) { alert(err.response?.data?.error || 'Could not open the damage photo'); }
  };
  if (failed) return <div style={{ fontSize:10, color:'#f87171', marginTop:8 }}>📷 Damage photo unavailable</div>;
  if (!url) return null;
  return (
    <a href="#damage-photo" onClick={openFull} rel="noopener noreferrer" style={{ display:'block', marginTop:8 }}>
      <img src={url} alt="damage" style={{ width:'100%', maxHeight:120, objectFit:'cover', borderRadius:6, border:'1px solid rgba(245,158,11,0.3)' }} />
      <div style={{ fontSize:10, color:'#e2e8f0', marginTop:3 }}>📷 Tap to view full size</div>
    </a>
  );
}
